import React, { useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import {
  addRole,
  fetchRolesList,
  updateRole,
} from "../../services/axios/apiManager";
import { Formik } from "formik";
import * as Yup from "yup";
import LoadingSpinner from "../../Components/spinner";
import { toast } from "sonner";

const AddEditRoleModal = ({
  setSelectedRole,
  selectedRole,
  setShowModal,
  showModal,
  setRoles,
}) => {
  const [loading, setLoading] = useState(false);
  // // // Close Add Edit Role
  const handleCloseAddEditModal = () => {
    setSelectedRole({});
    setShowModal(false);
  };
  const roleValidations = Yup.object().shape({
    name: Yup.string()
      .trim()
      .min(2, "Role name must be at least 2 characters")
      .max(100, "Role name cannot exceed 100 characters")
      .required("Role name is required"),
  });
  // // // Add Edit Role Logic
  const handleAddEditRole = async (data) => {
    if (selectedRole?.id) {
      const editResponse = await updateRole({ id: selectedRole.id, ...data });
      if (editResponse?.status === 200) {
        if (editResponse?.data?.success) {
          const response = await fetchRolesList();
          if (response?.data?.data) {
            setRoles(response.data.data);
          }
          toast.success("Role has been updated!", { duration: 2000 });
        }
        handleCloseAddEditModal();
      } else {
        toast.error(
          editResponse?.data?.message ||
            "Role has not been updated, try again!",
          {
            duration: 2000,
          }
        );
      }
    } else {
      const addResponse = await addRole(data);
      if (addResponse?.status === 200) {
        const response = await fetchRolesList();
        if (response?.data?.data) {
          setRoles(response.data.data);
        }
        toast.success("Role has been added", {
          duration: 2000,
        });
        handleCloseAddEditModal();
      } else {
        toast.error(
          addResponse?.data?.message || "Role has not been added, try again!",
          {
            duration: 2000,
          }
        );
      }
    }
  };
  return (
    <Modal
      show={showModal}
      onHide={handleCloseAddEditModal}
      centered
      className="text-light"
      backdrop="static"
    >
      <Modal.Header closeButton className="bg-dark text-light border-0">
        <Modal.Title>{selectedRole?.id ? "Edit Role" : "Add Role"}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-dark text-light">
        <Formik
          initialValues={{
            name: selectedRole?.name || "",
            status: selectedRole?.status || 1,
          }}
          validationSchema={roleValidations}
          onSubmit={async (values) => {
            try {
              setLoading(true);
              await handleAddEditRole(values);
            } catch (error) {
              console.log("Error upon Add Update Role", error);
            } finally {
              setLoading(false);
            }
          }}
        >
          {({
            handleChange,
            setFieldValue,
            handleSubmit,
            values,
            errors,
            touched,
          }) => (
            <div>
              <Form.Group className="mb-3">
                <Form.Label>Role Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter role name"
                  required
                  value={values.name}
                  onChange={handleChange("name")}
                  className="bg-dark text-light border-light input-placeholder-light"
                  data-testid="Role-Name"
                />
                {errors?.name && touched?.name ? (
                  <span className="text-danger">{errors?.name}</span>
                ) : null}
              </Form.Group>
              {/* <Form.Group className="mb-3">
                <Form.Label>Status</Form.Label>
                <Form.Select
                  value={values.status}
                  onChange={handleChange("status")}
                  className="bg-dark border-light text-light"
                  data-testid="Status"
                >
                  <option value="1">Active</option>
                  <option value="0">Inactive</option>
                </Form.Select>
              </Form.Group> */}
              <div className="constainer-fluid">
                <div className="d-flex justify-content-end">
                  {loading && (
                    <div className="mt-4 mx-2">
                      <LoadingSpinner size={"lg"} />
                    </div>
                  )}
                  <Button
                    variant="secondary"
                    onClick={() => {
                      handleCloseAddEditModal();
                    }}
                    className="mt-3 mx-2"
                  >
                    Close
                  </Button>
                  <Button
                    variant="success"
                    className="mt-3"
                    data-testid="Add-New-Role"
                    onClick={() => {
                      handleSubmit();
                    }}
                  >
                    {selectedRole?.id ? "Update" : "Add New Role"}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
};
export default AddEditRoleModal;
